import axiosApi from "../axiosInstance";
import { getReduxCompany } from "../../helper/sessionHelper";

const getProjectList = async () => {
    try {
        const response = await axiosApi.post(`Project/GetProjectList`);
        return response?.data;
    } catch (error) {
        console.log("Error getProjectList===>:", error);
    }
};

const getProjectDropdown = async (body) => {
    try {
        const response = await axiosApi.post(`Project/GetProjectDropdown`, body);
        return response?.data;
    } catch (error) {
        console.log("Error getProjectDropdown===>:", error);
    }
};

const getProjectByUserId = async (userId) => {
    try {
        debugger
        let request = {};
        request.companyId = getReduxCompany()?.companyId || 0;
        const response = await axiosApi.post(`Project/GetProjectByUserId/` + userId, request);
        return response?.data;
    } catch (error) {
        console.log("Error GetProjectByUserId===>:", error);
    }
};

const addProject = async (body) => {
    try {
        const response = await axiosApi.post(`Project/CreateProject`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addProject===>", error);
    }
};

export const ProjectService = {
    getProjectList,
    addProject,
    getProjectDropdown,
    getProjectByUserId,
}